import React from 'react';
import Swal from 'sweetalert2';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAddBannedTerm } from '@hooks/useBannedTerms';
import { useRemoveBrowseNodeCategoryDealListMapping } from '@hooks/useBrowseNodeCategories';
import SpinningIcon from '@components/SpinningIcon';

const DeleteBrowseNodeMapping = ({
  contextFreeName,
  categoryId,
  dealListId,
  forever = true
}: {
  contextFreeName: string;
  categoryId: string;
  dealListId?: number;
  forever?: boolean;
}) => {
  const { mutate: addBannedTerm, isLoading: isDeleting } = useAddBannedTerm();
  const { mutate: removeMapping, isLoading: isRemoving } =
    useRemoveBrowseNodeCategoryDealListMapping();

  const warning = dealListId
    ? `Do you want to delete this browse node "${contextFreeName}" from ${
        forever ? 'all ' : 'this '
      }mapping? It will also prevent any future deals being mapped to this deal list from this mapping but not remove the ones already mapped.`
    : `Do you want to delete this browse node "${contextFreeName}" from ${
        forever ? 'all ' : 'this '
      }mapping?`;

  return (
    <Button
      variant={forever ? 'contained' : 'outlined'}
      onClick={() => {
        Swal.fire({
          title: 'Are you sure?',
          text: warning,
          showCancelButton: true,
          confirmButtonText: 'Delete',
          denyButtonText: `Don't delete`
        }).then((result) => {
          if (result.isConfirmed) {
            if (forever) {
              addBannedTerm({
                term: categoryId,
                type: 'BANNED_BROWSE_NODE_CATEGORY',
                exact: true
              });
            }

            if (dealListId) {
              removeMapping({
                categoryId,
                dealListId
              });
            }
          }
        });
      }}
      disabled={isDeleting || isRemoving}
      endIcon={
        isDeleting || isRemoving ? <SpinningIcon isLoading /> : <DeleteIcon />
      }
    >
      Delete mapping {forever ? 'forever' : ''}
    </Button>
  );
};

export default DeleteBrowseNodeMapping;
